<template>
    <v-card class="score-chart ma-1">
        <v-container>
            <v-card flat class="ma-1 pa-2 score-trans">
                <v-responsive>
                    <v-card-title class="caption-font">
                        <div>Your Bookings</div>
                        <div style="margin-right: 8px; margin-left: auto;">
                            <div style="display: flex; flex-direction: row;">
                                <div style="font-size: small; font-weight: 500; margin-right: 10px;">export matrix per acco</div>
                                <div style="width:30px;">
                                    <div v-if=loading>
                                        <v-progress-circular :width="3" :size="20" color="success" indeterminate></v-progress-circular>
                                    </div>
                                    <div v-else>
                                        <v-icon medium color="green" v-on:click="exportDataToExcel()">mdi-microsoft-excel</v-icon>       
                                    </div>
                                </div>
                            </div>
                        </div>                                       
                    </v-card-title>
                    <v-card-subtitle>Number of bookings for your portfolio</v-card-subtitle>
                    <v-container v-if="showchart">
                        <div style="height: 250px; width: 100%;">
                        <canvas id="bookingv7" height="300" style="width:100%;"></canvas>
                        </div>
                    </v-container>
                    <v-container v-else>
                        <div style="height: 250px; width: 100%; display: flex; align-items: center; justify-content: center;">
                            <div style="text-align: center; border: 1px solid red; padding: 10px !important; border-radius: 15px;"><div>No portfolio data showing?</div><div>You may be registered as an agent incorrectly</div><div>notify the <a href="mailto:ares@villaforyou.com">aresbox</a></div></div>                        
                        </div>    
                    </v-container>                    
                </v-responsive>
            </v-card>
            <v-card-actions></v-card-actions>
        </v-container>
    </v-card>
</template>

<script>

    import mxbookingschart from '../mixins/bookings_chart_v9';

    import { Chart, registerables } from 'chart.js';
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    Chart.register(...registerables, ChartDataLabels); // registered globally

    import {bus} from "../../../../main";

    export default {
        data() {
            return {
                bookingsTY: [],
                bookingsPY: [], 
                showchart: true,
                chart: null,
                loading: false,
            }
        },
        created(){ // set up event bus listener here on created event
            this.getBookingData('load');
            bus.$on("refresh", () => {
                this.getBookingData('refresh');                
            });
        },                  
        mixins:[mxbookingschart],
        methods:{
            refreshChart(object){
                this.chart.data.labels = object.data.labels;
                let i = 0;
                this.chart.data.datasets.forEach((dataset) => {
                   dataset.data = object.data.datasets[i].data;
                   i++;
                });
                this.chart.options = object.options;
                this.chart.update();
            },
            exportDataToExcel() {
                this.loading = true;
                this.$axios
                    .post("ares/json/ares/syst/dashboard/exportYourBookingsv2.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "exportRecentAgentBookings"
                        },
                    })
                    .then(res => {
                        if (res.data.error) {
                            this.loading = false;
                            console.log(res.data.error);
                        } else {
                            this.loading = false;
                            // console.log(res.data.exportRecentAgentBookings)
                            this.items = res.data.exportRecentAgentBookings;
                            window.open(this.items.filename, '_blank');
                        }
                    })
            },            
            getBookingData(param){  
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getBookingsByAgentv2.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getRecentBookings"
                        },
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.bookingsTY = res.data.getRecentBookingsThisYear;    
                            this.bookingsPY = res.data.getRecentBookingsPreviousYear;                  
                            // console.log(this.bookingsTY, this.bookingsPY, res.data.header.count)
                            res.data.header.count===0?this.showchart=false:this.showchart=true;  
                            if(this.showchart){
                                if(param ==='load'){
                                    const ctx = document.getElementById('bookingv7').getContext('2d');
                                    this.chart = new Chart(ctx, this.createBarData(this.bookingsTY, this.bookingsPY, "bar")); // horizontalBar, bar                                
                                } else {
                                    this.refreshChart(this.createBarData(this.bookingsTY, this.bookingsPY, "bar"));
                                }
                            }
                        }
                    })
            },             
        }
    }
</script>

<style scoped>
    .score-chart {
        background: url('../assets/not_a_sunset.png') !important;
        background-size: cover !important;
    }
    .intro-font {
        font-size: 20px;
    }
    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }
    .score-trans {
        background: transparent !important;
    }
</style>